import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ICarrier } from '@interfaces/carrier/carrier.interface';
import { Cache } from '@decorators/cache/cache.decorator';
import { ICarrierNumLines } from '@interfaces/carrier/carrier-num-lines.interface';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CarriersService {
  public selectedCarrier: Subject<Partial<ICarrier>> = new Subject<Partial<ICarrier>>();

  constructor(private api: ApiService) {}

  @Cache<Partial<ICarrier>[]>()
  public getAllCarriers(): Observable<Partial<ICarrier>[]> {
    return this.api.get('carrier/carriers');
  }

  public setSelectedCarrier(carrier: Partial<ICarrier>): void {
    this.selectedCarrier.next(carrier);
  }

  public getById(carrier_id: string): Observable<ICarrier> {
    return this.api.get('carrier/by_id', { carrier_id });
  }

  public getTopCarriersByZip(zip_code: string): Observable<ICarrier[]> {
    return this.api.get('carrier/top_carriers_by_zip', { zip_code });
  }

  public getCarrierNumLines(carrier_id: string): Observable<ICarrierNumLines> {
    return this.api.get('carrier/get_carrier_num_lines', { carrier_id });
  }
}
